{
    "applications": {
        "CUSTOMER": {
            "name": "Organizations",
            "icon": "ti ti-building",
            "routerLink":"/usermgmt/customer"
        },
        "USER": {
            "name": "Users",
            "icon": "ti ti-users",
            "routerLink":"/usermgmt/users"
        },
        "ROLE": {
            "name": "Roles",
            "icon": "ti ti-user-hexagon",
            "routerLink":"/usermgmt/roles"

        },
        "APPLICATION": {
            "name": "Applications",
            "icon": "ti ti-layout-2",
            "routerLink":"/usermgmt/applications"

        }
    }
}